import {
  SnackbarProvider,
  closeSnackbar,
  SnackbarProviderProps,
  MaterialDesignContent,
} from 'notistack';
import { Button, styled } from '@/theme/index';

export * from 'notistack';

const StyledWrapper = styled('div')({
  '.notistack-SnackbarContainer.z-index': {},
});

const StyledMaterialDesignContent = styled(MaterialDesignContent)(
  ({ theme }) => ({
    '&.notistack-MuiContent-success': {
      backgroundColor: theme.palette.notistackToast?.light,
      color: theme.palette.notistackToast?.main,
      '.MuiButton-root': {
        color: theme.palette.notistackToast?.dark,
      },
    },
    '&.notistack-MuiContent-error': {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
      '.MuiButton-root': {
        color: theme.palette.error.contrastText,
      },
    },
    '&.notistack-MuiContent-info': {
      backgroundColor: theme.palette.info.main,
      color: theme.palette.info.contrastText,
      '.MuiButton-root': {
        color: theme.palette.info.contrastText,
      },
    },
  })
);

export function AlertProvider(props: SnackbarProviderProps) {
  const { Components, ...rest } = props;
  const components = {
    ...{
      success: StyledMaterialDesignContent,
      error: StyledMaterialDesignContent,
      info: StyledMaterialDesignContent,
    },
    ...Components,
  };
  return (
    <StyledWrapper>
      <SnackbarProvider
        {...rest}
        Components={components}
        action={(snackbarId) => (
          <Button
            onClick={() => closeSnackbar(snackbarId)}
            variant="text"
            color="success"
          >
            Dismiss
          </Button>
        )}
        classes={{ containerRoot: 'z-index' }}
      />
    </StyledWrapper>
  );
}
